import { COLORS, TYPOGRAPHY } from 'Components/foundation';
import { createStyleSheet } from 'Components/foundation/stylesheets';

export default createStyleSheet({
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: 'white',
    padding: '128px 0px',
    borderRadius: 12,
  },
  emptySearchText: {
    ...TYPOGRAPHY.H2,
    color: COLORS.TEXT.SECONDARY_DEFAULT,
    marginTop: 32,
    textAlign: 'center',
  },
  emptySearchIcon: {
    marginTop: 15,
    alignSelf: 'center',
  },
});
